import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const OnMyMind = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - ON MY MIND</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - ON MY MIND</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                [Chorus]<br/>
                Got success, on my mind<br/>
                On my best all the time<br/>
                Always stay on the grind<br/>
                Are you stressed? Call my line<br/>
                We the ones coming up<br/>
                Want the smoke, oh what's up?<br/>
                Hit them like, guns to bust<br/>
                If they come at one of us<br/>
                <br/>
                Got success, on my mind<br/>
                On my best all the time<br/>
                Always stay on the grind<br/>
                Are you stressed? Call my line<br/>
                We the ones coming up<br/>
                Want the smoke, oh what's up?<br/>
                Hit them like, guns to bust<br/>
                If they come at one of us<br/>
                <br/>
                [Verse 1]<br/>
                Wild, I ain't with the disssing<br/>
                You won't make it out, you lack the discipline<br/>
                I'm kissing this chick and she gets in position<br/>
                And now I'm on top, just like my mission in life<br/>
                Envision it right, and lately<br/>
                Hoon spit kar raha truth, they running for safety<br/>
                You wanted to hate me<br/>
                You wanted to break me<br/>
                Aur Notion aur Human the ones that have made me aur<br/>
                Baate ye yaad rakh<br/>
                Chahe bura lage aaj waqt<br/>
                Hatash ho na jara bhi, chaiye kamiyaabi aakhri saas tak<br/>
                Hustle nai chodna, karte reh mehnat and<br/>
                Goals bachake rakh, just like a centerback<br/>
                Derahe ho wo shots, I make sure I send it back<br/>
                Kar te wo hate, kar sakte nai level match<br/>
                And in fact, how can we end<br/>
                This baby let's fucking be friends<br/>
                Don't wanna be stuck in deep ends<br/>
                Baby girl, I never pretend<br/>
                I don't wanna hold on cuz it's gets hard<br/>
                I feel so lost and it's pitch dark<br/>
                Broke my own heart trying to fix yours<br/>
                Saw all your colours like VIBGYOR<br/>
                But it still is my (rainbow) reign, bow down to me please<br/>
                And how does it feel that all of your dreams<br/>
                Are coming alive I already feel<br/>
                Tha ginti me alag like Counting Unique<br/>
                Man crown me the king, the best<br/>
                Laga raha kaam pe, need no rest<br/>
                Mana the streets believe in me<br/>
                Mai banunga G in the scene, I guess<br/>
                Man I said<br/>
                <br/>
                [Chorus]<br/>
                Got success, on my mind<br/>
                On my best all the time<br/>
                Always stay on the grind<br/>
                Are you stressed? Call my line<br/>
                We the ones coming up<br/>
                Want the smoke, oh what's up?<br/>
                Hit them like, guns to bust<br/>
                If they come at one of us<br/>
                <br/>
                Got success, on my mind<br/>
                On my best all the time<br/>
                Always stay on the grind<br/>
                Are you stressed? Call my line<br/>
                We the ones coming up<br/>
                Want the smoke, oh what's up?<br/>
                Hit them like, guns to bust<br/>
                If they come at one of us<br/>
                <br/>
                [Verse 2]<br/>
                Shukriya they mere saath jo before the fame<br/>
                Parwa meri inhe hone na hone se<br/>
                Har roj ek kadam lu sapno ki or<br/>
                Mere kandho pe bojh almost breaking my shoulder blade<br/>
                Thode se mile jab views to count<br/>
                Piche ye pade in huge amounts<br/>
                You were the one that they used to doubt<br/>
                Now you're the one brother, you stood out<br/>
                Naam hai ab faila jo hali me<br/>
                Har jagah sunu bas taarife<br/>
                Drop kara beginning/big inning maine, lambi paari ka khiladi mai<br/>
                Wo chahte girana, par hausle they kayam<br/>
                Mai pehchaanu nasal se, bohot dekhe kayar<br/>
                Their confidence dropping, get locked in a coffin<br/>
                Wo bhaukte par pohochte nai gaush level high up<br/>
                Ab wo kar rahe drain meri energy<br/>
                Agar tu nai dost, you a enemy<br/>
                Mai kehra hu GAUSH is greater than god, and can't nobody put an end to me<br/>
                Always wanna get respect, I kept working<br/>
                Nobody finna step to test my best version<br/>
                I'm coming with the tech, protect your neck<br/>
                Worse than a brother living check to check and debt burdens him<br/>
                Ladne ki thaan li jab se<br/>
                Mehnat kari maine liya maine kaam akal se<br/>
                Tabhi laga raha chahe mili khali sadke<br/>
                Dage mile tabhi laga sahi raah pe chalne<br/>
                Ab ye aagaye vash me, har jagah pe kabze<br/>
                Bolu jo bhi man me aaye, tha nidar mai<br/>
                Pada saalo se band tha khali ghar me ab<br/>
                Na jaanu kaise lage mujhe bahar nikal ke<br/>
                Havi sar pe bhoot<br/>
                Hani par jawab kalam se du<br/>
                Taarif har pal, naaz ye karte kyu?<br/>
                Aag lage mai jahape kardu shoot<br/>
                Alone in my zone<br/>
                I just go with the motion<br/>
                I'm rolling with Notion<br/>
                Unspoken emotions<br/>
                Got so many foes<br/>
                See me flowing so cold<br/>
                I eat all of the bones, even though I'm a G.O.A.T<br/>
                Man I said<br/>
                <br/>
                [Chorus]<br/>
                Got success, on my mind<br/>
                On my best all the time<br/>
                Always stay on the grind<br/>
                Are you stressed? Call my line<br/>
                We the ones coming up<br/>
                Want the smoke, oh what's up?<br/>
                Hit them like, guns to bust<br/>
                If they come at one of us<br/>
                <br/>
                Got success, on my mind<br/>
                On my best all the time<br/>
                Always stay on the grind<br/>
                Are you stressed? Call my line<br/>
                We the ones coming up<br/>
                Want the smoke, oh what's up?<br/>
                Hit them like, guns to bust<br/>
                If they come at one of us<br/>
                <br/>
                [Outro]<br/>
                Refix got the beat boy<br/>
                Hanh, sabko boht pyaar<br/>
                Pyaar failao, nafrat boht badh gayi hai<br/>
                Peace
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default OnMyMind;
